// 首页-生态
<template>
  <div class="home-ecological">
    <div class="info">
      <div class="title">生态技术</div>
      <p class="content"></p>
    </div>
    <div class="index_tech_list">
      <div class="index_tech_item">
        <div
          class="index_tech_item_img index_tech_item_img_1"
          :class="iconIsLeave1"
          @mouseleave="iconIsLeave1 = 'mouse-out-class'"
          @mouseenter="iconIsLeave1 = ''"
          @click="goPath('/ecologicalCoreTechnology')"
        ></div>
        <div class="index_tech_item_title">核心技术</div>
      </div>
      <div class="index_tech_item">
        <div
          class="index_tech_item_img index_tech_item_img_2"
          :class="iconIsLeave2"
          @mouseleave="iconIsLeave2 = 'mouse-out-class'"
          @mouseenter="iconIsLeave2 = ''"
          @click="goPath('/ecologicalWaic')"
        ></div>
        <div class="index_tech_item_title">世界人工智能大会</div>
      </div>

      <div class="index_tech_item">
        <div
          class="index_tech_item_img index_tech_item_img_3"
          :class="iconIsLeave3"
          @mouseleave="iconIsLeave3 = 'mouse-out-class'"
          @mouseenter="iconIsLeave3 = ''"
          @click="goPath('/ecologicalInstitute')"
        ></div>
        <div class="index_tech_item_title">研究院</div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'home_ecological',
  data() {
    return {
      iconIsLeave1: "", //技术生态icon是否鼠标离开标记
      iconIsLeave2: "",
      iconIsLeave3: "",
    }
  },
  methods: {
    goPath(path) {
      this.$router.push(path);
    }
  }
}
</script>
<style lang="less" scoped>
.home-ecological {
  width: calc(100% - 148px);
  height: 100%;
  background: #ffffff;
  padding: 0 74px 0px;
  display: flex;
  flex-direction: column;
  .info {
    margin-top: 170px;
    .title {
      font-size: 44px;
      line-height: 60px;
      text-align: center;
    }
    .content {
      font-size: 24px;
      font-weight: 400;
      color: #08204D;
      line-height: 44px;
    }
  }
  .mouse-out-class {
    /*0.5s执行移出动画*/
    animation: mouse-out 0.5s;

    /*移出动画依然分成20步骤*/
    animation-timing-function: steps(23);

    /*动画结束时停在最后一帧*/
    animation-fill-mode: forwards;
  }
  .index_tech_list {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: space-around;
    margin-top: 33px;
    flex: 1;
    .index_tech_item {
      height: 33.3%;
      margin: 0 auto;
      text-align: center;
      .index_tech_item_img {
        width: 140px;
        height: 140px;
        margin: 0 auto;
        transform: scale(1.3);
        &:hover {
          /*hover时用0.5s执行mouse-in动画*/
          animation: mouse-in 0.5s;

          /*这一句极其重要，将mouse-in拆成23个步骤执行（还记得我们那张长图总共有多少张小图吗）*/
          animation-timing-function: steps(23);

          /*动画执行结束后，停在最后一帧上*/
          animation-fill-mode: forwards;
        }
      }
      @keyframes mouse-in {
        /*鼠标移入时从第一张移动到最后一张*/
        from {
          background-position-y: 0;
        }
        to {
          background-position-y: -3220px; /*1280px就是图片的总长度，即64px 20张*/
        }
      }
      @keyframes mouse-out {
        /*鼠标移出时从最后一张移动回第一张*/
        from {
          background-position-y: -3220px;
        }
        to {
          background-position-y: 0;
        }
      }
      .mouse-out-class {
        /*0.5s执行移出动画*/
        animation: mouse-out 0.5s;

        /*移出动画依然分成20步骤*/
        animation-timing-function: steps(23);

        /*动画结束时停在最后一帧*/
        animation-fill-mode: forwards;
      }
      .index_tech_item_img_1 {
        background: transparent
          url("../../../static/img/home/tech_item_1.png") 0 0 no-repeat;
          background-size: 100%;
          cursor:pointer;
      }
      .index_tech_item_img_2 {
        background: transparent
          url("../../../static/img/home/tech_item_2.png") 0 0 no-repeat;
          background-size: 100%;
          cursor:pointer;
      }
      .index_tech_item_img_3 {
        background: transparent
          url("../../../static/img/home/tech_item_3.png") 0 0 no-repeat;
          background-size: 100%;
          cursor:pointer;
      }
      .index_tech_item_title {
        font-size: 36px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #08204D;
        line-height: 44px;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/view/home/home_ecological.vue